var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayPrimary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 0c9.388 0 17 7.61 17 17 0 9.388-7.612 17-17 17S0 26.388 0 17C0 7.61 7.612 0 17 0z",
    fill: "#42ABE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.21 24A1.218 1.218 0 0112 22.783V11.216a1.208 1.208 0 011.832-1.044l9.581 5.785a1.219 1.219 0 010 2.086l-9.581 5.785a1.205 1.205 0 01-.623.172z",
    fill: "#fff"
  })));
}
export default SvgPlayPrimary;